<template>
    
    <div  class="  ac-transition">
        <div class="card">
              <button type="reset" @click="printReceipt" class="btn b-light btn-danger-light btn-sm">Print Receipt</button>
        </div>
        <div class="grid grid-cols-12">
  <div id="receipt"  class="receipt">
    <div class="receipt-container  ">
      <h3 class="dn_f_only text-center"><strong> {{setting[1]?.settingvalue}} </strong></h3>
      <p class="dn_f text-sm text-center">{{setting[2]?.settingvalue}}</p>
      <p class="dn_f text-sm text-center">📞 {{setting[3]?.settingvalue}} </p>
      <div class="border"></div>
      <table class="table">
          <tr> 
              <td  style="font-size:12px;" >
                  <strong class="">Name</strong> : {{customer.name}}<br>
                  
              </td>
              <td  style="font-size:12px;">
                   <strong class="">No</strong> : {{invDetails.id}}
                  
              </td>
            </tr> <tr style="font-size:12px;">  
                    <!--<td  ><strong class="">Contact</strong> : {{customer.cell}}</td>-->
                    <td><strong class="">Date</strong> : {{invDetails.entry_date}}<br></td>
          </tr>
          
      </table>     
      <table class="receipt-table">
        <thead>
          <tr class="border">
            <th style="width:10%;text-align:center" class="dn_f">Sr.</th>
            <th style="width:40%" class="dn_f">Details </th>
            <th style="width:10%;text-align:center" class="dn_f">Qty(Mtr) </th>
            <!--<th style="width:10%;text-align:center" class="dn_f">QTY </th>-->
            <th style="width:10%;text-align:center" class="dn_f">Rate</th>
            <th style="width:10%;text-align:center" class="dn_f">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item ,index) in order_items" :key="item.id">
            <td style="text-align:center;font-size:12px;">{{ index+1 }}</td>
            <td style="font-size:12px;">{{ (item.stich_name)?item.stich_name:item.prd_name }}({{item.barcode === '0' ? '--' : item.barcode}})</td>
            <td style="text-align:center;font-size:12px;" >{{ item.pieceqty }} ({{ parseFloat(item.pieceqty * item.meterqty).toFixed(2)}})</td>
            <!--<td style="text-align:center;font-size:12px;" >{{  parseFloat(item.qty)*-1 }} ({{item.pieceqty }})</td>-->
            <!--<td style="text-align:center;font-size:12px;" >{{  (parseFloat(item.qty)*parseFloat(item.pieceqty))* -1 }} </td>-->
            <td style="text-align:right;font-size:12px;">{{ formatCurrency(item.rate) }}</td>
            <!--<td style="text-align:right;font-size:12px;">{{ formatCurrency(item.rate * (item.pieceqty )) }}</td>-->
            <td style="text-align:right;font-size:12px;">{{ formatCurrency(item.rate * (parseFloat(item.qty)*-1 )) }}</td>
          </tr>
           
          
          
        </tbody> 
        <tfoot>
          <!-- <tr v-show="invDetails.delivery">
            <td colspan="5"><strong>Delivery Date : {{ invDetails.delivery }}</strong></td>
          </tr> -->
          <tr v-if="invDetails.discount">
            <td colspan="3"><strong class="dn_f">Sub Total</strong></td>
            <td  colspan="2"  style="font-size:14px;text-align: end;"> {{ formatCurrency(invDetails.total) }}</td>
          </tr>
          <tr v-if="invDetails.discount && invDetails.discount!=0">
            <td colspan="3"><strong class="dn_f">Discount</strong></td>
            <td  colspan="2" style="font-size:14px;text-align: end;">- {{ formatCurrency(invDetails.discount) }}</td>
          </tr>
          
          <tr>
            <td colspan="3"><strong class="dn_f">Total</strong></td>
            <td  colspan="2"  style="font-size:14px;text-align: end;">{{ formatCurrency(invDetails.sub_total) }}</td>
          </tr>
          <!--<tr>-->
          <!--  <td colspan="4"><strong class="dn_f">ऍडव्हांस</strong></td>-->
          <!--  <td>{{ formatCurrency(invDetails.paid) }}</td>-->
          <!--</tr>-->
          <!--<tr>-->
          <!--  <td colspan="4"><strong class="dn_f">येणे बाकी</strong></td>-->
          <!--  <td>{{ formatCurrency(invDetails.total-invDetails.paid) }}</td>-->
          <!--</tr>-->
        </tfoot>
      </table> 
      
          <div v-if="qrCodeDataUrl" class="text-center" style="    text-align: -webkit-center;">
          <h3>Scan to Pay</h3>
          <img style="width:50%"  :src="qrCodeDataUrl" alt="UPI QR Code" />
        </div>
        
       <h2 style="
    text-align: center;
    font-weight: 600;    padding: 5px;    padding-bottom: 0;
">* मान्यवर ग्राहकास नम्र विनंती *</h2>
 
     <table border="1" cellpadding="2" cellspacing="0" style="border-collapse: collapse; font-weight: 400;">
   
    <tbody>
        <tr>
            <td>1</td>
            <td>कुठल्याही प्रकारची गॅरंटी आम्हास कोणतेही कंपनी देत नाही. त्यामुळे आम्हासही आपणास कुठल्याही प्रकारची गॅरंटी देता येत नाही.</td>
        </tr>
        <tr>
            <td>2</td>
            <td>एकदा विकलेला माल कोणत्याही सबबीवर परत घेतला जाणार नाही व बदलून दिले जाणार नाही.</td>
        </tr>
    </tbody>
</table>
       <p class="dn_f text-sm text-center" style="    margin-top: 10px;">{{setting[4]?.settingvalue}}</p>
    </div>
  </div>
        </div>
        </div>
</template>

<script>
import axios from 'axios';
import QRCode from "qrcode";
export default {
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
      receiptNumber: '',
      customer:[],
      invDetails:[],
      order_items:[], 
      setting:[],
      upidata:[],
      qrCodeDataUrl:''
       
    };
  },
  computed: {
    totalAmount() {
      return this.items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
    },
  },
  mounted() { 
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
      
        async getBasics(invoiceid) {
          const self = this;
        
          try {
            // ✅ Await the axios call — no "async" before axios.post!
            const response = await axios.post('getInvoice', { invoiceid });
        
            self.order_items = response.data.order_items;
            self.employees = response.data.userDetails;
            self.invDetails = response.data.invDetails;
            self.customer = response.data.customer;
            self.setting = response.data.setting;
            self.upidata = response.data.upidata;
        
            // Remove loader safely
            try {
              document.getElementById("loader")?.remove();
            } catch (e) {
              console.warn("Loader not found or already removed");
            }
        
            const amount = parseFloat(self.upidata.amount || 0).toFixed(2);
            if(amount && amount>0){
            const upiUrl = `upi://pay?pa=${encodeURIComponent(self.upidata.upiId)}&pn=${encodeURIComponent(self.upidata.payeeName)}&am=${encodeURIComponent(amount)}&cu=INR`;
        
                // ✅ Generate QR Code
                try {
                  self.qrCodeDataUrl = await QRCode.toDataURL(upiUrl);
                } catch (err) {
                  console.error("QR Code generation error:", err);
                }
            }
        
            // ✅ Call the print function
           self.$nextTick(() => {
              self.printReceipt();
            });
          } catch (err) {
            console.error("Error fetching invoice data:", err);
          }
        },
        
        
    //  async getBasics(invoiceid) {
    //       var self=this;
    //          axios.post('getInvoice',{invoiceid:invoiceid}).then(function (response) {
    //                      self.order_items=response.data.order_items;
    //                      self.employees=response.data.userDetails;
    //                      self.invDetails=response.data.invDetails;
    //                      self.customer=response.data.customer;
    //                      self.setting=response.data.setting;
    //                     try {
    //                         document.getElementById("loader").remove();  
    //                         sel.printReceipt();
    //                     } catch (e) {}
    //                 }).then(()=>{ 
                        
                        
                        
    //                      self.printReceipt();
                  
    //                     });;
    //   },
    formatCurrency(value) {
      return parseInt(value);//`$${value.toFixed(2)}`;
    },
    printReceipt() {
      window.print();
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@200;500&display=swap');
.dn_f { 
  font-family: 'Noto Sans Devanagari', sans-serif;
  font-size: 14px;
}
.dn_f_only { 
  font-family: 'Noto Sans Devanagari', sans-serif;
}
tbody,table,.border{
    border-bottom: 1px dashed;
}
 #receipt {
  font-family: monospace;
  font-size: 16px;
  width: 68mm; /* Common width for thermal printers */
  padding: 5px;
}
table {
  width: 100%;
}
td, th {
  padding: 5px;
  text-align: left;
}


@media print {
  button {
    display: none;
  }
 body {
        margin: -2rem 0 0 0;
        }
 #receipt {
   width: 250px; /* Ideal for thermal printers */
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.4;
  padding: 5px;
  
  /*border: 1px solid #000;*/
  margin: 0 auto;
  margin-top: -40px ;
  margin-left: 10px ;
  white-space: nowrap; /* Prevent text wrapping */
    }
    
    .dn_f_only{
      font-size: 16px;
      font-weight: 800;
    }
    .dn_f{
      font-size: 14px;
      
    }
}


</style>
